<svg viewBox="0 0 491 491" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_2_13)">
<path d="M491 143.76C491 106.997 476.767 70.1633 448.659 42.1266C392.514 -14.0184 301.538 -14.0184 245.393 42.1266C189.248 98.2715 189.248 189.248 245.393 245.393C189.248 189.248 98.2715 189.248 42.1265 245.393C-14.0184 301.538 -14.0184 392.514 42.1265 448.659C70.1632 476.696 106.997 491 143.76 491H491V143.76Z" fill="#FF0000"/>
</g>
<defs>
<clipPath id="clip0_2_13">
<rect width="491" height="491" fill="white"/>
</clipPath>
</defs>
</svg>
